import styles from "./pit-crew.module.scss"
import { useState, useEffect } from "react"

// Bios
import bios from "./assets/bios.json"
import { pictures } from "./assets/pictures/pictures"

// Images
import PitCrewImage from "../../assets/images/graphics/pit-overhead.jpg"
import OpenIcon from "../../assets/images/icons/touchpoint.svg"
import Close from "../../assets/images/icons/close.svg"
import Background from "../../components/background/background"

import { CosmosText, CosmosTitle } from "@cosmos/web-react"

// Returns the HTML markup for the pit crew slide
export default function PitCrew() {
	const [modalToggled, setModalToggled] = useState(false)
	const [activeProfile, setActiveProfile] = useState(null)

	// When the modalToggled state is changed
	useEffect(() => {
		if (!modalToggled) {
			setTimeout(() => {
				setActiveProfile(null)
			}, 350)
		}
	}, [modalToggled])

	return (
		<>
			<Background />

			<div className={styles.container}>
				<CosmosTitle
					size="xx-large"
					className={styles.title}>
					OUR PIT CREW
				</CosmosTitle>

				<img
					className={styles.pitcrew}
					src={PitCrewImage}
					alt="Pit Stop Overhead"
				/>

				<div className={styles.personToggles}>
					{bios.map((bio, index) => (
						<div
							key={index}
							className={styles.toggle}
							style={{
								backgroundImage: `url(${OpenIcon})`,
								left: `${bio.position.left}vw`,
								top: `${bio.position.top}vh`,
							}}
							onClick={() => {
								setModalToggled(true)
								setActiveProfile(bio)
							}}
						/>
					))}
				</div>
			</div>

			<div
				className={[styles.modal, modalToggled ? styles.isToggled : ""].join(" ")}
				onClick={() => setModalToggled(false)}>
				<div className={styles.card}>
					<img
						className={styles.closeTouchpoint}
						src={Close}
						alt="Close"
					/>

					<div className={styles.grid}>
						<div className={styles.imageContainer}>
							{pictures[activeProfile?.image] ? (
								<img
									className={styles.pictureProfile}
									src={`${pictures[activeProfile?.image]}`}
								/>
							) : (
								<div className={styles.pictureProfileNoImage}>
									<CosmosText size="medium">No Image Available</CosmosText>
								</div>
							)}
						</div>

						<div className={styles.textContainer}>
							<div className={styles.name}>
								<CosmosTitle
									weight="heavy"
									size="medium">
									{activeProfile?.name}
								</CosmosTitle>
							</div>

							<div className={styles.bio}>
								<CosmosText size="small">
									Position In Pit Crew:
									<br />
									<span>{activeProfile?.pit_position}</span>
								</CosmosText>

								{activeProfile?.fav_circuit && (
									<CosmosText size="small">
										Favourite Circuit:
										<br />
										<span>{activeProfile?.fav_circuit}</span>
									</CosmosText>
								)}

								{activeProfile?.fav_bull && (
									<CosmosText size="small">
										Favourite Red Bull:
										<br />
										<span>{activeProfile?.fav_bull}</span>
									</CosmosText>
								)}

								{activeProfile?.fav_moment && (
									<CosmosText size="small">
										Favourite Moment:
										<br />
										<span>{activeProfile?.fav_moment}</span>
									</CosmosText>
								)}

								{activeProfile?.fav_tune && (
									<CosmosText size="small">
										Favourite Tune:
										<br />
										<span>{activeProfile?.fav_tune}</span>
									</CosmosText>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
